import React, { useMemo } from 'react';
import { useParams } from 'react-router';
import * as S from './LocalPlacementsPage.styled';
import {
  LocalizationLinkedList,
  PreviewApp,
  PlacementsForm,
  Loader,
  ErrorComponent,
} from 'components';
import { publisherLocalizationPages } from 'constants';
import { routes } from 'config';
import { getUrl } from 'utils';
import { manageAppsAPI } from 'services/manageApps.service';

const LocalPlacementsPage = () => {
  const { pba_id } = useParams();

  const pages = useMemo(
    () =>
      publisherLocalizationPages.map((page) => {
        return { ...page, link: getUrl(routes, page.url_id, pba_id) };
      }),
    [],
  );
  const { data, isSuccess, isError } = manageAppsAPI.useGetPlacementsQuery(pba_id);

  return (
    <>
      {isError && <ErrorComponent />}
      {!isSuccess && !isError && <Loader.Global delay={1} />}
      {data && (
        <S.Container>
          <h1>App Settings</h1>
          <S.Main>
            <S.Wrap>
              <S.ListPosition>
                <PreviewApp />
                <LocalizationLinkedList data={pages} show={true} />
              </S.ListPosition>
              <PlacementsForm data={data} />
            </S.Wrap>
          </S.Main>
        </S.Container>
      )}
    </>
  );
};

export default LocalPlacementsPage;
